export default __webpack_public_path__ + "static/media/hero1.eb35d3de.jpg";